// @ts-nocheck




import React from 'react';

import { maintenanceOperationApi } from '../../lib/api';

import AutocompleteSelect from './AutocompleteSelect';

export default (selectProps) =>
<AutocompleteSelect
  placeholder="Выберите виды работ"
  fetch={async (params) =>
  await maintenanceOperationApi.fetchMaintenanceOperations({
    ...params
  })
  }
  fetchSingle={maintenanceOperationApi.fetchMaintenanceOperation}
  notFoundText="Виды работ не найдены"
  renderOption={(maintenanceOperation, Option) =>
  <Option
    key={maintenanceOperation.id}
    value={maintenanceOperation.id}
    maintenanceoperation={maintenanceOperation}>

        {maintenanceOperation.name}
      </Option>
  }
  {...selectProps} />;
